module.exports = __webpack_public_path__ + "img/20191221132032395.352f822a.jpg";